export default __webpack_public_path__ + "static/media/rectangleGroup.8b73a73c.svg";